import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

const VEHICLE_RESOURCE = "vehicle" as const;
export const VEHICLE_VALUATION_COPY_FOR_REEVALUATION_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/copy` as const;

export type VehicleValuationCopyForReevaluationResponse =
  paths[typeof VEHICLE_VALUATION_COPY_FOR_REEVALUATION_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export const useVehicleValuationCopyForReevaluationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationCopyForReevaluationResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }: { uuid: string }) => {
      const apiPath = VEHICLE_VALUATION_COPY_FOR_REEVALUATION_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.post<VehicleValuationCopyForReevaluationResponse>(apiPath);

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
